import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  imagePreview: {
    textAlign: 'center',
    width: '160px',
    height: '160px',
    margin: 'auto',
    color: theme.palette.text.secondary,
    /* offset-x | offset-y | blur-radius | color */
    /* offset-x | offset-y | blur-radius | spread-radius | color */
    boxShadow: 'inset 0 -3em 3em rgba(0,0,0,0.1), 0 0  0 2px rgb(255,255,255), 0.3em 0.3em 1em rgba(0,0,0,0.3)',
  },
  previewText: {
    width: '100%',
    marginTop: '20px',
  },
  image: {
    position: 'relative',
  },
  fileInput: {
    border: '4px solid lightgray',
    padding: '10px',
    cursor: 'pointer',
    transform: 'scale(0.5)',
  },
  imageUrl: {
    width: '160px',
    padding: '0 15px',
    margin: '15px 0',
  },
})

class ImageUploadBase64 extends React.Component {
  constructor(props) {
    super(props);
    this.classes = this.props.classes;
    this.value = this.props.value;
    this.onChange = this.props.onChange;
    this.state = {
      file: undefined,
      imagePreviewUrl: this.value,
      option: 'Upload image',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== prevState.imagePreviewUrl) {
      return { imagePreviewUrl: nextProps.value };
    }
    return null;
  }

  handleSelectOption = (e) => {
    this.setState({ option: e.target.value });
  }

  handleImageChange(e) {
    e.preventDefault();

    if (this.state.option === 'Upload image') {
      let reader = new FileReader();
      let file = e.target.files[0];

      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        });
        this.onChange(reader.result);
      }

      !!file && reader.readAsDataURL(file)
    } else {
      this.setState({
        file: '',
        imagePreviewUrl: e.target.value,
      });
      this.onChange(e.target.value);
    }
  }

  render() {
    let { imagePreviewUrl } = this.state;
    let imagePreview = null;
    if (imagePreviewUrl) {
      imagePreview = (<img src={imagePreviewUrl} width={160} height={160} className={this.classes.image} alt="Product" />);
    } else {
      imagePreview = (<div className={this.classes.previewText}>Please select an Image for Preview</div>);
    }

    return (
      <>
        <select className="form-select form-select-sm w-auto m-auto" value={this.state.option} onChange={this.handleSelectOption}>
          <option value="Upload image">Upload image</option>
          <option value="Image URL">Image URL</option>
        </select>
        <div className="d-flex flex-column justify-content-center align-items-center">
          {this.state.option === 'Upload image'
            ? (<input className={this.classes.fileInput}
              id={this.props.id}
              name={this.props.name}
              type="file"
              onChange={(e) => this.handleImageChange(e)} />)
            : (
              <input className={`form-control form-control-sm ${this.classes.imageUrl}`}
                id={this.props.id}
                name={this.props.name}
                type="text"
                value={this.state.imagePreviewUrl}
                onChange={(e) => this.handleImageChange(e)} />
            )}
          <div className={this.classes.imagePreview}>
            {imagePreview}
          </div>
        </div>
      </>
    )
  }
}

ImageUploadBase64.defaultProps = {
  value: '',
  id: '',
  name: '',
  onChange: (value) => value,
}

export default withStyles(styles)(ImageUploadBase64);